import React from 'react';
import ATselect from '@at.govt.nz/select';
import ATbutton from '@at.govt.nz/buttons';
import { ReactComponent as IconBusGrey } from '../../../assets/svg/bus-grey.svg';
import { ReactComponent as IconFerryGrey } from '../../../assets/svg/ferry-grey.svg';
import { ReactComponent as IconTrainGrey } from '../../../assets/svg/train-grey.svg';
import { SEARCH_MODE, getStopDescription } from '../../../services/TimetablesService';
import Schedule from './Schedule';
import { humanizeDaysDisplay } from '../../../utils/Humanizers';
import { ReactComponent as IconBackArrow } from '../../../assets/svg/back-arrow.svg';
import DownloadTimetableLink from './DownloadTimetableLink';
import { CATEGORIES, TIMETABLES_ACTION, logEvent } from '../../../services/AnalyticsService';
import AriaLiveMessage from '../../../components/AriaLiveMessage/AriaLiveMessage';

const bemEmpty = 'tt-timetable-empty';
const bem = 'tt-timetable';

export const greyIconMap = {
  [SEARCH_MODE.BUS]: <IconBusGrey className={`${bemEmpty}__greyicon ${bemEmpty}__greyicon--bus`} role="img" />,
  [SEARCH_MODE.TRAIN]: <IconTrainGrey className={`${bemEmpty}__greyicon ${bemEmpty}__greyicon--train`} role="img" />,
  [SEARCH_MODE.FERRY]: <IconFerryGrey className={`${bemEmpty}__greyicon ${bemEmpty}__greyicon--ferry`} role="img" />,
};

export const shouldShowLiveDeparture = stop => stop.pickup_type === 1;

// TODO: Consider removing searchMode and take from the selected data structure instead
export const GreyIcon = ({ searchMode }) => (!greyIconMap[searchMode] ? '[??]' : greyIconMap[searchMode]);

export default class Timetable extends React.PureComponent {
  constructor(props) {
    super(props);
    this.liveMessageRef = React.createRef();
  }

  onDaySelectorChangeLocal = (event) => {
    const { changeDaySelector } = this.props;
    const value = event.target.value;
    logEvent(CATEGORIES.TIMETABLES, TIMETABLES_ACTION.DATE_SELECT, event.target[value].text);
    changeDaySelector(value);
  };

  onClickBack = () => {
    const { clearTimetable } = this.props;
    clearTimetable();
  };

  onGotoLiveDepartures = () => {
    const { selectedStop, gotoLiveDepartureRequest, history } = this.props;
    logEvent(CATEGORIES.TIMETABLES, TIMETABLES_ACTION.LIVE_DEPARTURES, selectedStop);
    gotoLiveDepartureRequest(selectedStop, history);
  };

  render() {
    const {
      timetables, selectedDayIndex, selectedStop, loadingTimetable, searchMode,
    } = this.props;

    const options = !timetables ? [] : timetables.map((item, index) => ({
      value: `${index}`, // item.days.join(':'),
      text: humanizeDaysDisplay(item.days),
    }));


    // Timetable loading screen
    if (loadingTimetable) {
      return (
        <div className={`${bem}--loading loader`}>
          <AriaLiveMessage message="Loading schedule" readAfter={100} />
        </div>
      );
    }

    // Empty timetable screen
    if (!timetables) {
      return (
        <div className={`${bemEmpty}`}>
          <GreyIcon {...this.props} />
          <div className={`${bemEmpty}__text`}>Choose a stop to view timetable</div>
        </div>
      );
    }

    // Populated timetable screen
    const disableLiveDeparture = shouldShowLiveDeparture(selectedStop); // TODO: Create actual business logic for this!!
    const schedule = timetables.length <= 0 ? [] : timetables[selectedDayIndex].schedule;

    return (
      <div className={`${bem}`}>
        <div className={`${bem}__back-container`}>
          <div data-testid={`${bem}__back-btn`} className={`${bem}__back-content`} onClick={this.onClickBack} role="none">
            <IconBackArrow className={`${bem}__back-content-svg`} role="img" />
            <span className={`${bem}__back-content-text`}>Back</span>
          </div>
        </div>
        <div className={`${bem}__header`}>
          {/* eslint-disable-next-line jsx-a11y/no-noninteractive-tabindex */}
          <h2 className={`${bem}__title`} tabIndex="0">
            <AriaLiveMessage ref={this.liveMessageRef} message="Schedule for" />
            {getStopDescription(selectedStop)}
          </h2>
          <div className={`${bem}__download-link`}><DownloadTimetableLink {...this.props} /></div>
          {
            options.length <= 0 ? <p className={`${bem}__empty-schedule`}>There are no schedules for this stop</p>
              : (
                <ATselect
                  data-testid={`${bem}__select`}
                  className={`${bem}__select`}
                  dark={false}
                  options={options}
                  block
                  onChange={this.onDaySelectorChangeLocal}
                  value={selectedDayIndex}
                  aria-label="Select days of week"
                />
              )

          }

        </div>

        <div className={`${bem}__schedule`}><Schedule schedule={schedule} searchMode={searchMode} /></div>
        {
          !disableLiveDeparture
          && (
            <div className={`${bem}__livedepartures`}>

              <ATbutton
                aria-label="View live departures"
                block
                className={`${bem}__livedepartures-button`}
                data-testid={`${bem}__livedepartures-button`}
                disabled={disableLiveDeparture}
                onClick={this.onGotoLiveDepartures}
                tabIndex={0}
              >
                View live departures
              </ATbutton>
            </div>
          )
        }
      </div>
    );
  }
}
